import { Button, Modal, message } from "antd";
import { registerLogoutHandler } from "./logoutHandler";
import {
  ExpenseDraft,
  ExpenseDraftFormValue,
} from "@/pages/Expenses/RecordExpense/types/expenseDraft";

interface ExpenseLogoutDependencies {
  drafts: ExpenseDraft[];
  submitDrafts: (payload: {
    expenses: ExpenseDraftFormValue[];
    delete_drafts?: string[];
  }) => Promise<any>;
}

/**
 * Register the expense logout handler for the Record Expense page
 * @param dependencies - The dependencies to register the logout handler
 */
export const registerExpenseLogoutHandler = (
  dependencies: ExpenseLogoutDependencies
) => {
  registerLogoutHandler("/expenses/record", async () => {
    const { drafts, submitDrafts } = dependencies;

    if (!drafts || drafts.length === 0) {
      return true; // No drafts, proceed with logout
    }

    // Show confirmation modal for unsaved drafts
    return new Promise((resolve) => {
      Modal.confirm({
        title: "You have expense drafts",
        content: "Do you want to submit the expense drafts and logout?",
        okText: "Submit and Logout",
        cancelText: "Cancel",
        maskClosable: true,
        onOk: async () => {
          try {
            const newValue = drafts.map((draft: ExpenseDraftFormValue) => ({
              user_id: draft?.user_id,
              expense_type_id: draft?.expense_type_id,
              date: draft?.date,
              description_id: draft?.description_id,
              supplier_id: draft?.supplier_id,
              price: draft?.price,
              quantity: draft?.quantity,
              unit_id: draft?.unit_id,
              staff_name: draft?.staff_name,
            }));

            await submitDrafts({ expenses: newValue });
            message.success("Successfully submitted all expenses");
            resolve(true); // Proceed with logout
          } catch (error) {
            message.error("Failed to submit expenses. Please try again.");
            resolve(false); // Don't logout on error
          } finally {
            Modal.destroyAll();
          }
        },
        onCancel: () => {
          resolve(false); // Cancel logout
        },
        footer: (_, { OkBtn, CancelBtn }) => (
          <>
            <CancelBtn />
            <Button
              onClick={() => {
                resolve(true);
                Modal.destroyAll();
              }}
              danger
            >
              Logout
            </Button>
            <OkBtn />
          </>
        ),
      });
    });
  });
};
